
<template>
  <div>
    
    <v-stepper v-model="stepper" vertical class="ml-1 mr-1 elevation-0" >
      <v-stepper-step :complete="stepper > 1" step="1" :editable="stepper > 1">
        Identificação
      </v-stepper-step>
      <v-stepper-content :complete="stepper > 1" step="1">
        <v-col cols="12">
          <v-card color="white lighten-1" class="mb-2 pa-3" height="">
            <v-form ref="marketPlaceForm" v-model="is_valid_market_place">
              <v-autocomplete 
                v-model="marketPlace.brand" 
                :items="brands" 
                :rules="required"
                label="De qual Marca esse local se refere?"
                prepend-icon="mdi-domain" 
                hide-no-data 
                item-text="name" 
                item-value="id"
              ><v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition></v-autocomplete>
              <v-text-field 
                v-model="marketPlace.fantasyName" 
                :rules="required"
                label="Nome Fantasia"
                prepend-icon="mdi-information"
              ></v-text-field>
              <v-text-field 
                v-model="marketPlace.CNPJ" 
                label="CNPJ" 
                prepend-icon="mdi-information"
                :rules="cnpj" 
                v-mask="'##.###.###/####-##'"
              ></v-text-field>
            </v-form>
          </v-card>
          <v-btn text @click="stepper = 1" disabled><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
          <v-btn text @click="() => { if($refs.marketPlaceForm.validate()){ stepper = 2; } }"><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
        </v-col>
      </v-stepper-content>

      <v-stepper-step :complete="stepper > 2" step="2" :editable="stepper > 2">
        Endereço
      </v-stepper-step>

      <v-stepper-content :complete="stepper > 2" step="2">
        <v-card color="white lighten-1" class="mb-2 pa-3">
          <AddressForm ref="addressForm" :address="marketPlace.address_attributes"> </AddressForm>
        </v-card>
        <v-btn text @click="stepper = 1"><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
        <v-btn text @click="() => { if($refs.addressForm.validate()){ stepper = 3; fastName() } }"><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="stepper > 3" step="3" :editable="stepper > 3">Produtos Existentes</v-stepper-step>

      <v-stepper-content step="3">
        <card-loading-transparent v-if="loading"></card-loading-transparent>
        <v-col cols="12" v-if="!loading && stepper == 3">
          <v-card color="white lighten-1" class="mb-2 pa-3" height="">
            <v-form ref="productsForm" v-model="is_valid_products">
              <v-text-field v-model="marketPlace.name" :rules="[...required]" label="Nome simplificado" prepend-icon="mdi-check" class="estado"></v-text-field>
              <div v-for="p in all_products" :key="p.id">
                <v-checkbox multiple :label="p.name" :value="p.id" v-model="marketPlace.products" :id="p.name" @change="$forceUpdate()"></v-checkbox>
              </div>
            </v-form>

            <v-row v-if="all_products.length == 0">
              <v-col cols="12" class="d-flex justify-center">
                Nenhum produto encontrado para a marca selecionada.
              </v-col>
              <v-col cols="12" class="d-flex justify-center">
                Adicione novos produtos à marca para criar o novo local de retirada.
              </v-col>
            </v-row>
          </v-card>
          <v-btn text @click="stepper = 2"><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
          <f-btn save @click="submitMarketPlace()" :disabled="marketPlace.products.length < 1"></f-btn>
        </v-col>
      </v-stepper-content>
    </v-stepper>
    <dialog-loading v-if="saving" loadingText="Salvando"></dialog-loading>
  </div>
</template>

<script>
import validations from "@/mixins/validations";
import getters from "@/_backoffice/_registrations/mixins/getters.js"
import Api from "@/api/index"

export default {
  name: 'RegisterPickupLocation',
  mixins: [ getters, validations ],
  props: {
    brands: {
      type: Array,
      default(){return []},
    },
  },
  components:{
    AddressForm: () => import("@/_backoffice/_registrations/components/shared/forms/AddressForm.vue"),
  },
  data() {
    return {
      is_valid_market_place: true,
      is_valid_products: true,
      stepper: 1,
      loading: true,
      cep: '',
      all_products: [],
      marketPlace: {
        status_id: 1,
        brand: null,
        fantasyName: '',
        corportaName: '',
        name: '',
        CNPJ: '',
        address_attributes: {
        },
        product_pickup_locations_attributes: [],
        products: [],
      },
      saving: false,
    }
  },
  methods: {
    getProducts(){
      this.loading = true
      Api.SupplierV2.index('products', { 
        brand_id: this.marketPlace.brand,
        without_ppl: true
      }).then(r=> {
        this.all_products = r.data
      }).catch(err=> {
        console.log(err)
        this.addNotification({type: 'error',  msg: 'Ops... Ocorreu um erro.'})
      }).finally(() => {
        this.loading = false
      })
    },
    genPPL() {
      this.marketPlace.products.forEach(e => {
        this.marketPlace.product_pickup_locations_attributes.push({ 'product_id': e, 'status_id': 1 })
      });
    },
    submitMarketPlace() {
      this.saving = true;
      this.swallConfirmation({
        title: `Deseja cadastrar local de retirada?`,
        icon: 'question',
      }).then( confirmed =>{
        if ( confirmed ) {
          this.genPPL();
    
          Api.Supplier.createMarket(this.marketPlace).then(r => {
            this.addNotification({type: 'success',  msg: 'Local de retirada ' + this.marketPlace.fantasyName + ' cadastrado com sucesso!'})
            this.stepper = 1;
            this.resetInfos()
          }).catch(err => {
            this.addNotification({type: 'error',  msg: err})
            console.log({err})
          }).finally(() => {
            this.saving = false;
          })
          
        }
      })
    },
    fastName() {
      var brand_index = this.brands.map(brand => brand.id).indexOf(this.marketPlace.brand)
      this.marketPlace.name = this.brands[brand_index].name + ' - ' + this.marketPlace.address_attributes.city;
    },
    resetInfos(){
      this.$refs.marketPlaceForm.reset()
      this.$refs.productsForm.reset()

      this.marketPlace = {
        status_id: 1,
        brand: '',
        fantasyName: '',
        corportaName: '',
        name: '',
        CNPJ: '',
        address: {
          cep: '',
          logradouro: '',
          complemento: '',
          bairro: '',
          localidade: '',
          uf: '',
        },
        addressNumber: '',
        address_attributes: {
        },
      }
      this.marketPlace.product_pickup_locations_attributes = []
      this.marketPlace.products = []
    },
  },
  watch: {
    stepper(newValue, oldValue) {
      if(newValue == 3){
        this.getProducts();
      }
    }
  },
}
</script>
